import {
  type UserInterfaceFlag,
  type useUserInterfaceFlags_fragment$key,
} from '#app/__generated__/relay/useUserInterfaceFlags_fragment.graphql.js';
import { graphql, useFragment } from '@contra/relay';

/**
 * This hook returns the UserAccount.userInterfaceFlags. It requires a valid Relay ref
 * to a UserAccount query.
 */
export const useUserInterfaceFlags = ({
  accountRef,
}: {
  accountRef?: null | useUserInterfaceFlags_fragment$key;
}): readonly UserInterfaceFlag[] => {
  const flags = useFragment(
    graphql`
      fragment useUserInterfaceFlags_fragment on UserAccount {
        userInterfaceFlags
      }
    `,
    accountRef,
  );

  return flags?.userInterfaceFlags ?? [];
};
